import axiosInstance from "auth/FetchInterceptor";
import { ADDITION_OPTION } from "constants/ApiConstant";
const AdditionOptionService = {};

AdditionOptionService.getAllAdditionOptions = function (partnerId) {
  return axiosInstance.get(`${ADDITION_OPTION}/${partnerId}`, null);
};

AdditionOptionService.upsertAdditionOption = function (data) {
  return axiosInstance.post(ADDITION_OPTION, data);
};

AdditionOptionService.deleteAdditionOption = function (id) {
  return axiosInstance.delete(`${ADDITION_OPTION}/${id}`, null);
};

export default AdditionOptionService;
